import React from 'react';

import ThemeContext from './ThemeContext';

const ThemeConsumer = ({ children }) => {
  return <ThemeContext.Consumer>{theme => children(theme)}</ThemeContext.Consumer>;
};

export default ThemeConsumer;
